import { render, staticRenderFns } from "./SeletorDeFormaDePagamentoDaPreVenda.vue?vue&type=template&id=1ba6ab35&"
import script from "./SeletorDeFormaDePagamentoDaPreVenda.vue?vue&type=script&lang=ts&"
export * from "./SeletorDeFormaDePagamentoDaPreVenda.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VCol,VSelect})
